// Urls
export const GET_PERSONAL_DATA_API = 'subscriber/profile/get/personalData';
export const UPDATE_PERSONAL_DATA_API =
	'subscriber/profile/update/personalData';

export const GET_PERSONAL_ADDRESS_API = 'subscriber/address/get';
export const UPDATE_PERSONAL_ADDRESS_API = 'subscriber/address/update';

// Queries
export const PERSONAL_DATA_QUERY_KEY = 'PERSONAL_DATA_QUERY_KEY';
export const PERSONAL_ADDRESS_QUERY_KEY = 'PERSONAL_ADDRESS_QUERY_KEY';
